import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PaymentAuthProvider } from './routes/ProtectedRoute';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <PaymentAuthProvider>
                <App />
            </PaymentAuthProvider>
        </BrowserRouter>
    </React.StrictMode>
);

reportWebVitals();